<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentcolor">
    <path
      d="M17.837 6.01A4.788 4.788 0 0 1 15.66 2h-3.44l-.006 13.78a2.889 2.889 0 1 1-2.884-3c.29.002.577.047.852.135v-3.51a6.336 6.336 0 0 0-.852-.063A6.335 6.335 0 0 0 3 15.671 6.339 6.339 0 0 0 9.33 22a6.336 6.336 0 0 0 6.329-6.329V8.684a8.177 8.177 0 0 0 4.783 1.539v-3.44c-.925.001-1.83-.268-2.605-.774Z"
    />
  </svg>
</template>

<script>
export default {};
</script>
